import { render, staticRenderFns } from "./Organizations.vue?vue&type=template&id=0735b4f1&scoped=true&"
import script from "./Organizations.vue?vue&type=script&lang=ts&"
export * from "./Organizations.vue?vue&type=script&lang=ts&"
import style0 from "./Organizations.vue?vue&type=style&index=0&id=0735b4f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0735b4f1",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VFadeTransition,VFlex,VLayout})


/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0735b4f1')) {
      api.createRecord('0735b4f1', component.options)
    } else {
      api.reload('0735b4f1', component.options)
    }
    module.hot.accept("./Organizations.vue?vue&type=template&id=0735b4f1&scoped=true&", function () {
      api.rerender('0735b4f1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organizations/Organizations.vue"
export default component.exports